import debounce from "debounce";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../components/loader/Loader";
import OneTournament from "../../../../components/oneTournament/OneTournament";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import {
  fetchTournamentsByQuery,
  resetSearchResults,
} from "../../../../features/tournamentSearch/tournamentSearchSlice";
import styles from "./searchForTournament.module.css";

const SearchForTournament = () => {
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const { cache, results, status } = useSelector(
    (state) => state.tournamentSearch
  );

  const debouncedSearch = useRef(null);

  useEffect(() => {
    debouncedSearch.current = debounce((value) => {
      if (!value) {
        dispatch(resetSearchResults());
        return;
      }

      if (cache[value]) {
        dispatch({
          type: "tournamentSearch/updateResultsFromCache",
          payload: cache[value],
        });
      } else {
        dispatch(fetchTournamentsByQuery(value));
      }
    }, 500);

    return () => {
      if (debouncedSearch.current && debouncedSearch.current.cancel) {
        debouncedSearch.current.cancel();
      }
    };
  }, [dispatch, cache]);

  const handleSearch = useCallback((e) => {
    const value = e.target.value;
    setQuery(value);

    if (debouncedSearch.current) {
      debouncedSearch.current(value);
    }
  }, []);

  return (
    <SettingsPagesContainer title="البحث عن بطوله">
      <div className={styles.searchInputWrapper}>
        <TextInput
          height="50px"
          width="400px"
          borderRadius="10px"
          placeHolder="البحث عن بطولة"
          bgColor={"grey"}
          bordered={true}
          value={query}
          onChange={(e) => handleSearch(e)}
        />
      </div>
      {status === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : (
        results.length > 0 &&
        results.map((item) => {
          return (
            <OneTournament
              tournamentId={item._id}
              key={item._id}
              status={item.status}
              name={item.name}
              serialNumber={item.serialNumber}
              createdBy={item.createdBy}
              startDate={item.startDate}
              endDate={item.endDate}
              description={item.description}
              prize={item.prize}
              tournamentImage={item.tournamentImage}
              prizeDescription={item.prizeDescription}
              enPrizeDescription={item.enPrizeDescription}
              requiredAds={item.requiredAds}
              requiredAdsByRegion={item.requiredAdsByRegion}
              playersCount={item.playersCount}
              stage={item.stage}
              liveLink={item.liveLink}
              gameName={item.gameName}
              tournamentType={item.tournamentType}
              maxUsersByTeam={item.maxUsersByTeam}
            />
          );
        })
      )}
    </SettingsPagesContainer>
  );
};

export default SearchForTournament;
